import React, * as r from 'react';

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"

import { ShowPosts, Post } from '../../types';
import PostParts from '../parts/PostParts';
import PostPartsDummy from '../parts/PostPartsDummy';
import { Stores } from '../../services/store/index';

export default function TwoColumnsPosts(props: {
  posts: ShowPosts,
}) {

  const stores = Stores.useContainer()
  const PostCompoment = stores.isDummy === "AllDummy" || stores.isDummy === "PostDummy" ? PostPartsDummy : PostParts

  return (
    <React.Fragment>
      {/* <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
      > */}
      <Masonry
        className={'my-gallery-class'}
        columnsCount={2}
      >
        {props.posts.map((post, index) => {
          return (
            <PostCompoment
              key={`post${index}`}
              post={post}
              style={{ width: "100%" }}
            />
          )
        })}
      </Masonry>
      {/* </ResponsiveMasonry> */}
    </React.Fragment >
  );
}